import PropTypes from 'prop-types';
// import {query} from 'api';
import {Slide, Image, ProductName} from './styles';

const CarouselSlide = ({slideData}) => (
  <Slide>
    <Image src={slideData.recette_produit_images} />
    <ProductName>{slideData.recette_produit_nom}</ProductName>
  </Slide>
);

CarouselSlide.propTypes = {
  slideData: PropTypes.object,
};

export default CarouselSlide;
